import { Language } from '@generated/base-types';

export const uiLanguageOptions: { label: string; value: Language }[] = [
  { label: 'common.languages.de', value: Language.De },
  { label: 'common.languages.fr', value: Language.Fr },
  { label: 'common.languages.en', value: Language.En }
];
